export default `
  fragment ImageButtonElement on BoothDesignImageButtonElement {
    normalStateImage {
      ...CommonLocalizableImage
    }
    hoverStateImage {
      ...CommonLocalizableImage
    }
    actionType
    actionExternalLinkUrl
    actionLocalizableExternalLinkUrl {
      values(locales: $locales) {
        locale
        value
      }
    }
    name: keyName
  } 
`;
